import Helper from '../../../../common/utils/helper';

export default class History {
    private currentTab: HTMLElement;

    private previousTab: HTMLElement;

    private modalElement: HTMLElement;

    fontClass: RegExp;

    constructor() {
        this.currentTab = null;
        this.previousTab = null;
        this.fontClass = /\bfont-\d\b/g;
        this.modalElement = document.getElementById('modalHistory');
        this.init();
    }

    init() {
        this.updateNextTabSize(document.querySelector('.nav-link.active'));
        this.initTabEvents();
        this.resetModalOnOpen();
        this.initOpenModalEvent();
    }

    resetModalOnOpen() {
        this.modalElement.addEventListener('hidden.bs.modal', () => {
            this.modalElement.querySelector('.modal-content').innerHTML = '';
        });
    }

    initOpenModalEvent() {
        document.querySelectorAll("[data-bs-target='#modalHistory']").forEach((button) => {
            button.addEventListener('click', () => this.getHistory());
        });
    }

    getHistory() {
        const url = document.querySelector('.tab-pane.show.active').getAttribute('data-detail');
        fetch(url, {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                this.modalElement.querySelector('.modal-content').innerHTML = data;
            });
    }

    initTabEvents() {
        const tabEl = document.querySelectorAll('button[data-bs-toggle="pill"]');
        tabEl.forEach((tab) => {
            tab.addEventListener('shown.bs.tab', (event: any) => {
                this.currentTab = event.target;
                this.previousTab = event.relatedTarget;
                this.updatePreviousTabSize(this.currentTab);
                this.updateNextTabSize(this.currentTab);
            });
        });
    }

    updateTabSize(elements: Element[]) {
        if (elements.length > 0) {
            elements.forEach((element, index) => {
                if (element.className.match(this.fontClass)) {
                    element.className = element.className.replace(this.fontClass, `font-${index}`);
                } else {
                    element.classList.add(`font-${index}`);
                }
            });
        }
    }

    updatePreviousTabSize(element: Element) {
        const previousSibiling = Helper.getElementPreviousSibilings(element);
        this.updateTabSize(previousSibiling);
    }

    updateNextTabSize(element: Element) {
        const nextSibilings = Helper.getElementNextSibilings(element);
        this.updateTabSize(nextSibilings);
    }
}

// On document ready
document.addEventListener('DOMContentLoaded', () => {
    (() => new History())();
});
